var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.783 7.429 2.103.236a.715.715 0 0 0-1.063 0 .85.85 0 0 0 0 1.142L7.191 8l-6.15 6.622a.851.851 0 0 0 0 1.142.715.715 0 0 0 1.062 0L8.784 8.57a.86.86 0 0 0 0-1.142Z",
    fill: "#A8BAC9"
  })));
};
export default SvgChevronRight;